import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role, loading } = useAuth();
  if (loading) return null;

  if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (allowedRoles && (!role || !allowedRoles.includes(role.slug))) {
    return <Navigate to="/login" replace />;
  }


  return children;
};

export default PrivateRoute;
